module.exports = __webpack_public_path__ + "img/building95-4.1b864bcf.jpg";